let api = {}
api.postLogin = '/oauth/token' //登录
api.getlistNum = '/v1/card/get/list' //获取人员（卡）列表
api.getTenant = '/v1/card/get/tenant' //获取入住人员信息

api.getDeviceItems = '/v1/device/get/items' //获取设备信息

api.unbindCard = '/v1/site/unbind/card' //解绑房间
api.bindCard = "/v1/site/bind/card" //绑定房间
api.setTenant = "/v1/card/set/tenant" //绑定房间

api.addCard = "/v1/card/add" //创建人员（卡）
api.updateCard = "/v1/card/update" //修改卡信息
api.deleteCard = "/v1/card/delete" //删除卡
api.postrenewal = "/v1/leases/update"  // 续租
api.getAutoRetreat="/v1/leases/to/retreat" // 同步合同状态
api.postUpdateLeases="/v1/leases/update" // 修改合同

api.exportCard = "/v1/card/export" //导出卡信息
api.exportSite = "/v1/site/export" //导出房源信息
api.exportDeviceOrder = "/v1/device/export/DeviceOrder" //导出设备信息


api.getTree = "/v1/site/get/tree" //获取所有房源
api.getSiteList = "/v1/site/get/list" //获取房间列表信息
api.getIntegration = "/v1/card/get/integration" //获取房间列表信息
api.deleteSite = "/v1/site/delete" //房源批量删除
api.removeAssign = "/v1/site/remove/assign" //解绑
api.siteAssign = "/v1/site/assign" //绑定
api.siteAddRoot = "/v1/site/add/root" //房源创建根级
api.siteUpdate = "/v1/site/update" //房源修改
api.sitCreateMod = "/v1/site/create/mod" //房源创建模板
api.sitAddChild = "/v1/site/add/child" //房源创建下一级
api.sitAddNodes = "/v1/site/add/nodes" //房源批量创建下一级
api.getSiteTenant = "/v1/site/get/tenant" //获取已入住人员信息

api.sendCommand = "/v1/device/send/command" //通用接口

api.getCertificates = "/v1/device/certificate/list" //凭证列表获取
api.updateCertificates = "/v1/device/update/certificate" //凭证列表修改
api.deleteCertificates = "/v1/device/delete/certificate" //凭证列表删除
api.addCertificates = "/v1/device/add/certificate" //添加凭证
api.getDeviceList = "/v1/device/get/list" // 查询设备列表
api.getDeviceResult = "/v1/device/get/command/result" // 查询反馈日志列表
api.unbindDeviceSite = "/v1/device/unbind/site" // 解除绑定房间
api.deleteDevice = "/v1/device/delete/device" // 删除设备
api.bindDeviceSite = "/v1/device/bind/site" // 绑定房间

api.fingerprintTransfer = "/v1/device/isp/fingerprintTransfer" //下发指纹
api.getDeviceRegisterManager = "/v1/device/isp/registerManager" // 重置添加管理员
api.getDeviceOperateUserInfo = "/v1/device/isp/operateUserInfo" // 下发凭证用户命令
api.DeviceRegisterDevice = "/v1/device/isp/registerDevice" // 设备初始化
api.openLock = "/v1/device/isp/openLock" //远程开锁

// api.fingerprintTransfer = "/v1/device/onenet/fingerprintTransfer" //下发指纹
// api.getDeviceRegisterManager = "/v1/device/onenet/registerManager" // 重置添加管理员
// api.getDeviceOperateUserInfo = "/v1/device/onenet/operateUserInfo" // 下发凭证用户命令
// api.DeviceRegisterDevice = "/v1/device/onenet/registerDevice" // 设备初始化
// api.openLock = "v1/device/onenet/openLock"//远程开锁

api.getOpenRecord = "/v1/device/get/open/record" //获取开门数据

api.bindRole = "/v1/account/bind/role" //用户绑定角色
api.getUserList = "/v1/account/user/list" //获取用户列表
api.getRoleList = "/v1/account/role/list" //获取角色信息
api.getRoleList = "/v1/account/role/list" //获取角色信息
api.updateRole = "/v1/account/update/role" //修改角色权限
api.deleteRole = "/v1/account/role/delete" //删除角色
api.addRole = "/v1/account/add/role" //添加角色

api.getStatisticsTotal = "/v1/statistics/get/total" // 获取房间总数
api.getStatisticsVacancy = "/v1/statistics/get/vacancy" // 查询空房总数
api.getTenantCount="/v1/statistics/get/tenant/count"//查询入住人数

api.getOperateList = "/v1/log/operate/list" // 获取操作日志
api.getExceptionList = "/v1/log/exception/list" // 获取操作日志
api.getLockAlert = "/v1/device/get/lock/alert" // 获取警告日志

api.getCheckCode = "/v1/account/checkCode" // 获取验证码
api.checkCodeMatches = "/v1/account/checkCode/matches" // 校验验证码
api.addUser = "/v1/account/add/user" // 添加用户
api.queryList = "/v1/card/query/list" //获取卡号（IMEI）
api.countStatus = "/v1/card/count/status" //获卡状态统计
api.lateOpenLock = "/v1/statistics/late/open/lock" //晚归
api.unOpenLockByDay = "/v1/statistics/unOpen/lock" //不在校

api.analysis = "/v1/statistics/analysis" //电量统计
api.userInfo = "/v1/account/user/info" //用户信息
api.getEnterprise = "/v1/account/get/enterprise" //查询所属部门
api.addEnterprise = "/v1/account/add/enterprise" //添加部门

api.getHeartbeat = "/v1/statistics/get/heartbeat" //获取心跳

api.editPassword = "/v1/account/edit/password" //修改登录账户
api.deleteUser = "/v1/account/delete/user" //删除用户
api.updateEnterprise = "/v1/account/update/enterprise" //更新部门信息


api.lockDeviceInfoList = "/v1/device/refresh/list" //刷新设备信息
api.getLockAlert1 = "/v1/device/refresh/alert" //门锁报警日志刷新
api.getOpenRecordList = "/v1/device/refresh/record" //开锁日志刷新
api.getHeartbeat1 = "/v1/device/refresh/  " //心跳刷新
api.deleteEnterprise = "/v1/account/delete/enterprise" //删除部门
api.assignSite = "/v1/site/assign" //房源和部门绑定
api.setEnterprise = "/v1/site/set/enterprise" //房源和部门绑定
api.infoImport = "/v1/card/infoImport" //批量导入

api.getMark = "/v1/card/get/mark" //获取指纹库
api.addMark = "/v1/card/add/mark" //导入指纹库
api.deleteMark = "/v1/card/delete/mark" //删除信息库
api.editMark = "/v1/card/edit/mark" //编辑信息库

api.onlySiteDevice = "/v1/card/only/siteDevice" //查询房间和设备数据
api.onlyTenant = "/v1/card/only/tenant" //查询房间和人员信息

api.export = "/v1/device/export/openRecord" //导出接口
api.editType = "/v1/account/edit/type" //修改类型
api.orderKill = "/v1/account/order/kill" //强制删除登录用户
api.editUserEnterprise = "/v1/account/edit/user/enterprise" //修改账户部门
api.getDeletes = "/v1/account/get/deletes" //获取已删除账户
    // ZG
api.ZGdeleteDevice = "/v1/zg/deleteDevice" //删除设备
api.ZGregisterDevice = "/v1/zg/registerDevice" //注册平台
api.ZGduserOperation = "/v1/zg/userOperation" //添加用户

api.formDataCommand = "/v1/device/send/fromData" //formdata指纹
api.sendEmergence = "/v1/device/send/emergence" //发送离线密码短信
api.getProjects = "/v1/statistics/get/project" //获取项目下门锁总数
api.getRolesByUser = "/v1/account/get/role" //获取用户对应角色
api.orderLockOpen = "/v1/statistics/order/openLock" //获取开锁记录
api.lockOpenStatistics = "/v1/statistics/statistics/openLock" //获取当天开锁记录时间间隔
api.alertTypeStatistics = "/v1/statistics/alert/type" //获取警告日志统计
api.cancelDistribution = "/v1/device/delete/by/serial"//取消下发指令
api.syncCommands = "/v1/device/syncCommands"  //从paas同步能对应得上的有效凭证
api.orderDeviceData = "/v1/device/order/deviceData" //获取指定锁所有非703凭证数据

api.editConfig = "/v1/auto/edit/config" //修改配置
api.getConfig = "/v1/auto/get/config" //获取配置
api.editQuota="/v1/device/edit/quota/{id}/{quota}"//修改lincense
api.edutLicense="/v1/device/edit/license"//edutLicense



api.getPlaceList = "/v1/place/get/list" //获取房间列表信息
api.addNodes="/v1/place/add/nodes"//创建房源
api.createModPlace="/v1/place/create/mod"//创建房源
api.updatePlace="/v1/place/update"//更新房源信息
api.deleteRoom="/v1/place/delete"//删除房源信息
api.addRoot="/v1/place/add/root"//添加根目录
api.getList="/v1/houseSensor/get/list"//获取警告日志
api.getReportList="/v1/houseSensor/report/list"//获取警告日志
api.registerDevice="/v1/houseSensor/isp/registerDevice"//注册设备
api.bindSite="/v1/houseSensor/bind/site"//绑定地点
api.getAlarmUser="/v1/place/get/alarm"//获取联系人
api.addAlarmUser="/v1/place/add/alarm"//添加联系人
api.unbindSite="/v1/houseSensor/unbind/site"//解绑地点
api.deleteAlarm="/v1/place/delete/alarm"//删除联系人
api.deleteAlarmUser="/v1/pay/delete/alarmUser"//删除联系人
api.updateAlarm="/v1/place/update/alarm"//更新联系人
api.editAlarmUser="/v1/pay/edit/alarmUser"//更新联系人
api.monitorDevices="/v1/place/monitor/devices"//统计设备总数和房间总数
api.getOrderReport="/v1/houseSensor/order/report"//根据类型和指定天数范围获取报警记录
api.getReports="/v1/houseSensor/get/reports"//获取所有报警信息
api.siteDevices="/v1/houseSensor/site/device"//获取所关系
api.deviceReport="/v1/houseSensor/export/report"
api.monitorReport="/v1/houseSensor/monitor/report"

api.updatePush="/v1/push/paas/update/push"//修改反馈日志状态
// fluorite
api.fluoriteRegisterDevice="/v1/ys/registerDevice"//注册设备
api.fluoriteDeleteDevice="/v1/ys/deleteDevice"//注销设备

api.deviceLink="/v1/ys/deviceLink"//子设备关联
api.deviceUnlink="/v1/ys/deviceUnlink"//子设备解除关联
// 注册设备集成接口
api.registerDeviceAll="/v1/device/all/registerDevice"

api.getAirSwitch="/v1/device/get/airSwitch"//获取空开信息
api.getAirSwitchParameter="/v1/device/get/device/parameter"//获取空开列表
api.getAirSwitchParameter="/v1/device/get/device/parameter"//获取空开列表
api.personBindEnterprise="/v1/card/bind/enterprise"//人员绑定部门
api.personUnBindEnterprise="/v1/card/unbind/enterprise"//人员解绑部门
api.getPersonBindEnterprise="/v1/card/get/enterprise"//获取人员绑定部门
api.getBase64Code="/test/en/aed"//
api.getUserid="/work/wechat/convert_to_userid"//获取企业微信userid

api.createKey="/auto/create/key"//创建普通用户
api.orderCreateKey="/v1/card/number/create/key"//生成普通用户账号
api.editMyKey="/v1/account/edit/myKey"

api.createOrder="/v1/pay/createOrder"//充值
api.createkeyCard = '/v1/card/order/create/key' //传人员id生成可登录的小程序用户
api.getOrderList="/v1/pay/list"//充值

// 接警联系人
api.lockAddAlarmUser="/v1/pay/add/alarmUser"//添加联系人
api.lockAlarmUsers="/v1/pay/alarmUsers"//获取联系人
api.rechargeAlarmBalance="/v1/pay/recharge/alarmBalance"
api.getAlwaysOpensApi="/v1/device/alwaysOpen/list"
// 设备状态统计筛选

api.screenStatisticsItems="/v1/statistics/device/items"

api.editPushBySerial = '/v1/device/editPush/bySerial'//更新操作日志状态

api.getlockOpenType = '/v1/statistics/lockOpen/type'//获取开锁类型统计

api.getBalance='/v1/pay/get/balance'//获取余额
api.postAccessControl = '/v1/device/get/accessControl ' //大学城获取门禁 {"url": 带HTTP的完整路径, "data": 请求参数, "code": 0为post，1为get}


api.postLeasesList="/v1/leases/get/list" // 获取合同列表
api.editLincense='/v1/device/edit/license'//授权

api.InvalidCertificateTask="/v1/device/test/InvalidCertificateTask"//手动刷新过期凭证删除

api.getContracts='/v1/auto/getContracts'//获取所有合同模板
api.getLeasesStatusstatistics="/v1/leases/status/statistics" // 首页数据获取
api.postDeleteLeases="/v1/leases/delete" // 删除合同
api.postAddLeases="/v1/leases/add" // 创建合同
api.sendSigningNotice = '/v1/leases/to/signingNotice' // 签约成功通知

api.forceSend="/v1/device/force/sendCommand"//强制发送指令状态result字段为700的命令

api.getCommunityrentStatistics = '/v1/leases/communityrent/statistics' //缴费的截至时间大于或等于当日时间，都算租金收缴成功
api.getCommonStatistics = '/v1/leases/common/statistics' //按社区、按状态 分组统计房间总数
api.getStatisticsByMonth = '/v1/leases/statisticsByMonth/' // 入住统计
api.getRoomStatistics = '/v1/leases/room/statistics' //按社区进行房屋总数统计
api.getStatisticsRevenueTop = '/v1/leases/statistics/revenueTop' // 收入排行

api.getfacepic = '/file/uploadFile'   // 上传人脸图片
api.getWaterMeterList = '/v1/device/waterMeterList'   // 获取水表列表
api.getWaterMeterReadRecordList = '/v1/device/waterMeterReadRecordList'   // 获取水表记录
api.getElectricityMeterList = '/v1/device/electricityMeterList'   // 获取电表列表
api.getElectricityMeterReadRecordList = '/v1/device/electricityMeterReadRecordList'   // 获取电表记录
api.getGatewayList = "/v1/device/gatewayList"//获取网关
api.getExtract = "/v1/api/feature/extract"//上传图片获取人脸特征
api.gatewayBindEnterprise = "/v1/device/gateway/bindEnterprise"//网关绑定企业

api.createUpdateContractHandle='/v1/auto/contractHandle'//新建或修改合同模板
api.getOrderContract='/v1/auto/getOrderContract'//查询指定模板
api.deleteContracts='/v1/auto/deleteContracts'//删除模板
api.miniPrepayOrder = '/v1/pay/miniPrepayOrder'//交租订单
api.rentPrepayOrder = '/v1/pay/rentPrepayOrder'//订单

api.getPriceHydropower = "/v1/price/get/list"//获取水电计费价格
api.addPriceHydropower = "/v1/price/add"//添加水电计费价格
api.deletePriceHydropower = "/v1/price/delete/meterPrice"//删除水电计费价格
api.updatePriceHydropower = "/v1/price/update/meterPrice"//修改水电计费价格

api.getLabelList = "/v1/label/List"//获取标签
api.getLabelReadRecordList = "/v1/label/labelRecordList" //获取标签详情

api.resendList = "/v1/device/reSendList"//批量重发
api.resendAll = "/v1/card/test/command/resend"//重发
api.newserialNumber = "/v1/card/new/serialNumber"// 更新凭证
// 登录限制配置
api.PostSafetyCap = "/v1/account/edit/safetyCap"//"ufc":5,"umc":180,"ult":2 输錯5次，180分钟重置次数，锁定2分钟

api.uploadMedia = '/v1/auto/uploadMedia' //文件上传

// 报修
api.getRepairOrders = "/v1/repairOrders/get/list"
api.addRepairOrders = "/v1/repairOrders/add"
api.deleteRepairOrders = "/v1/repairOrders/delete"
api.updateRepairOrders = "/v1/repairOrders/update"

export {
    api
}



// WEBPACK FOOTER //
// ./src/api/all.js